import { render } from "./NewAdminNavigationBar.vue?vue&type=template&id=17afa6ef"
import script from "./NewAdminNavigationBar.vue?vue&type=script&lang=js"
export * from "./NewAdminNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__